import React from 'react'

import ArticleListItem from "./ArticleListItem"
import RichTextItem from "./RichTextItem"
import ImageWithQuoteContainer from "./ImageWithQuoteContainer"
import FullWidthImageWithQuote from "./FullWidthImageWithQuote"
import FullWidthImageWithQuoteCarousel from "./FullWidthImageWithQuoteCarousel"
import QuoteSlice from "./QuoteSlice"
import ImageWithContent from "./ImageWithContent"
import YouTubeContent from "./YouTubeContent"
import ImageWithQuoteCarousel from './ImageWithQuoteCarousel'
import ShopTheLookSlice from './ShopTheLookSlice'
import LookbookSlice from './LookbookSlice'
import InstagramSlice from './InstagramSlice'
import AdvertBannerSlice from './AdvertBannerSlice'
import DoubleAdvertBannerSlice from './DoubleAdvertBannerSlice'
import Newsletter from '../Newsletter/Newsletter'
import DividerSlice from './DividerSlice'
import ImageGallery from './ImageGallery'

import map from 'lodash/map'

const SLICE_MAPPING = {
    article_list_item: (item, key) => <ArticleListItem item={item} key={key} />,
    text: (item, key) => <RichTextItem item={item} key={key} />,
    text_centered: (item, key) => <RichTextItem item={item} key={key} centered={true} />,
    image_with_quote: (item, key) => <ImageWithQuoteContainer item={item} key={key} />,
    image_with_quote_carousel: (item, key) => <ImageWithQuoteCarousel item={item} key={key} />,
    full_width_image_with_quote: (item, key) => <FullWidthImageWithQuote item={item} key={key}></FullWidthImageWithQuote>,
    full_width_image_with_quote_carousel: (item, key) => <FullWidthImageWithQuoteCarousel item={item} key={key}></FullWidthImageWithQuoteCarousel>,
    banner_image_with_content: (item, key) => <ImageWithContent item={item} key={key} />,
    banner_image_with_content_carousel: (item, key) => <ImageWithContent item={item} key={key} />,
    quote: (item, key) => <QuoteSlice item={item} key={key} />,
    youtube: (item, key) => <YouTubeContent item={item} key={key} />,
    shop_the_look_slice: (item, key) => <ShopTheLookSlice item={item} key={key} />,
    lookbook_gallery: (item, key) => <LookbookSlice item={item} key={key} />,
    instagram_slice: (item, key) => <InstagramSlice item={item} key={key} />,
    advert_banner: (item, key) => <AdvertBannerSlice item={item} key={key} />,
    double_advert_banner: (item, key) => <DoubleAdvertBannerSlice item={item} key={key} />,
    newsletter: (item, key) => <Newsletter key={key} />,
    divider: (item, key) => <DividerSlice key={key} />,
    image_gallery: (item, key) => <ImageGallery item={item} key={key} />
}

export default (bodyItems, lookbook=false) => {
    if(lookbook)
        return map( bodyItems, (item, index) => SLICE_MAPPING[item.slice_type] ? SLICE_MAPPING[lookbook && item.slice_type === "text" ? "text_centered" : item.slice_type](item, index) : null)
    return map( bodyItems, (item, index) => SLICE_MAPPING[item.slice_type] ? SLICE_MAPPING[item.slice_type](item, index) : null)
}



// WEBPACK FOOTER //
// ./src/components/Article/sliceMapper.js